var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00ACD2;}\r\n\t.st1{fill:#C8E9EB;}\r\n\t.st2{fill:#662D91;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.4,24.9c-6-5.2-19.3-7.7-29.2-0.3c-9.3,6.3-9.8,17.7-9.8,17.7c1.6,6.3,7.9,12.3,20.1,9.3 C59,43.3,61.8,22,79.4,24.9L79.4,24.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.1,45.3c-6.6,5.5-26.6,13.8-32.8-3C38.9,50.1,43,63.1,54.4,68c10.1,5,20.6-0.8,20.6-0.8 C79.6,62.7,81.7,54.4,73.1,45.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.3,37.6c8,3,25.1,15.8,13.7,29.6c7.5-2.6,16.3-12.6,14.8-24.9C89,31.1,79.4,24.9,79.4,24.9 C73.2,23.2,64.8,25.7,61.3,37.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppium);
export default __webpack_public_path__ + "static/media/Appium.c532edfb0efc1a7da395d124cd6aa9ef.svg";
export { ForwardRef as ReactComponent };